import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Solutions } from './components/Solutions';
import { Features } from './components/Features';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Team } from './components/Team';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-burgundy-950 text-parchment-100 font-body selection:bg-gold-500 selection:text-burgundy-950" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problems data-id="element-4" />
        <Solutions data-id="element-5" />
        <Features data-id="element-6" />
        <Pricing data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Team data-id="element-9" />
        <CTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}